import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* resetAccountPassword() {

  try {
    yield call(fetch, { api: api.profile.password_reset });

    yield put(actions.resetAccountPasswordDone());
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.resetAccountPasswordFailed,
      endpoint: api.profile.password_reset.url
    });
  }
}

export const resetAccountPasswordSaga = takeEvery(types.RESET_ACCOUNT_PASSWORD_REQUEST, resetAccountPassword);